import { render, staticRenderFns } from "./ReportShippedByCustomer.vue?vue&type=template&id=15896f54"
import script from "./ReportShippedByCustomer.vue?vue&type=script&lang=js"
export * from "./ReportShippedByCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports